<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="pagebrk">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Insemination</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style5" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->
            </div>
          </div>

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                  </div>
                </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-bold">Oocytes For Insemination</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          Oocyte Count
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Technique
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Prescribed By
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleInseminationByCycleController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OocyteCount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Technique}}{{l.OocyteQualityPost}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Remarks}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.PrescribedByName}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-bold">Insemination Log</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          <!--width-150px-->
                          Date &amp; Time
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          <!--width-150px-->
                          Processed By
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Doctor
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Processed By
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>-->
                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTimeText}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.ProcessedByName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          <div class="">{{l.DoctorName}}</div>
                          <div>{{l.NurseName}}</div>
                        </td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ProcessedBy}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>-->
                        <!--{{Details}}-->
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-bold">Summary:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">

              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                          ICSI
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          IMSI
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          IVF
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Total
                        </th>

                      </tr>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ICSICount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{IMSICount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{IVFCount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TotalCount}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family">Surgeon</label>
              </div>
              <div class="col-print-5">
                <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-4 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>-->

        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
